<template>
  <HeadlineComponent>Report: Catering</HeadlineComponent>
  <p>
    Hier die zusammengefassten Angaben der Crewmitglieder mit Schichten in
    diesem Event. Ausserdem werden alle Admins und Teamleads berücksichtigt.
  </p>
  <dl>
    <dt>Insgesamt</dt>
    <dd>{{ catering.total }}</dd>
    <dt>Egal</dt>
    <dd>{{ catering.omnivores }}</dd>
    <dt>Vegetarisch</dt>
    <dd>{{ catering.vegetarians }}</dd>
    <dt>Vegan</dt>
    <dd>{{ catering.vegans }}</dd>
  </dl>

  <h2>Allergien</h2>
  {{ catering.allergies }}
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import eventService from "@/services/event.service";
import * as Sentry from '@sentry/vue';

export default {
  name: "CateringView",
  data() {
    return {
      catering: {
        total: 0,
        vegan: 0,
        omnivores: 0,
        vegetarians: 0,
        allergies: "",
      },
    };
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
  },
  /*computed: {
    omnivore() {
      return this.user.slice().filter((u) => u.food_preference === 2).length;
    },
    vegetarian() {
      return this.user.slice().filter((u) => u.food_preference === 1).length;
    },
    vegan() {
      return this.user.slice().filter((u) => u.food_preference === 0).length;
    },
    allergies() {
      return this.user
        .slice()
        .filter((u) => u.food_allergies)
        .map((u) => u.food_allergies)
        .join(", ");
    },
  },*/
  async beforeRouteEnter(to, from, next) {
    let catering = {};
    try {
      let response = await eventService.cateringReport(to.params.event);
      catering = response.data;
      catering.allergies = catering.allergies.join(", ");
    } catch (e) {
      if (e) {
        console.log(e);
        Sentry.captureException(e);
        useAlertsStore().add(
          "danger",
          "Es ist was unerwartetes schief gegangen.."
        );
        window.scrollTo(0, 0);
      }
    }
    next((vm) => {
      vm.catering = catering;
    });
  },
  components: { HeadlineComponent },
};
</script>

<style scoped></style>
